import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { StartEndDate } from 'app/models/container-occupancy-report.model';
import { GeneralContainerReport } from 'app/models/general-container-report.model';
import { GeneralReport } from 'app/models/general-report.model';
import { GeneralZoneReport } from 'app/models/general-zone-report.model';

@Injectable()
export class GeneralReportService {

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {}

    getGeneralZoneReport(companyId: number,start,end): Promise<Array<GeneralZoneReport>> {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/GeneralZoneReport/" + companyId,sed)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    
    getGeneralContainerReport(companyId: number,start,end,polygonId): Promise<Array<GeneralContainerReport>> {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/GeneralContainerReport/" + companyId+"?polygonId="+polygonId,sed)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getGeneralReport(companyId,start,end,dateKey): Promise<Array<GeneralReport>> {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/GeneralReport/"+companyId+"?dateKey="+dateKey,sed)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

}
